/**
 * Team Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initTeam() {
        const blocks = document.querySelectorAll('.team');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] team block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTeam);
    } else {
        initTeam();
    }
})();